<template>
  <div class="property">
    <header>
      <a href="#back" @click.prevent="$router.go(-1)">
        <img :src="require('@/assets/images/chevron_left.svg')" class="icon" />
      </a>
    </header>
    <v-gallery :images="images" :index="index" @close="index = null"></v-gallery>
    <div class="image-area">
      <div class="image"
           v-for="(image, imageIndex) in images"
           :key="imageIndex"
           @click="index = imageIndex"
      >
        <img v-lazy="image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropertyPhotos',
  beforeCreate() {
    this.$store.commit('headerModeAuth');
    this.$store.commit('headerBack', true);
    this.$store.commit('headerSearch', false);
  },
  data() {
    return {
      index: null,
    };
  },
  computed: {
    images() {
      const { propertyId } = this.$route.params;
      const { properties } = this.$store.state;
      const selected = properties.find((property) => property.id === parseInt(propertyId, 10));
      if (!selected) return [];
      return selected.images.map((item) => item.cover);
    },
  },
};
</script>

<style scoped>
  .property{
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    background-color: var(--color-secondary-dark);
    z-index: 8001;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
  .property header{
    width: calc(100% + 60px);
    height: 60px;
    overflow: hidden;
    position: relative;
    top: 0;
    left: 0;
    z-index: 8002;
  }
  .property header .icon{
    position: fixed;
    top: 10px;
    left: 10px;
    animation: menu-in .3s linear forwards;
    animation-delay: .8s;
    opacity: 0;
  }
  .image-area{
    width: 100%;
    height: auto;
    position: relative;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .image{
    position: relative;
    width: calc(50% - 5px);
    height: 150px;
    overflow: hidden;
    display: inline-block;
    border-radius: 20px;
    margin-bottom: 5px;
    margin-left: 5px;
    background-size: cover;
  }
  .image img{
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
